"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IntermediateBuilder_1 = __importDefault(require("./IntermediateBuilder"));
var AndOperator_1 = __importDefault(require("../operators/AndOperator"));
var OrOperator_1 = __importDefault(require("../operators/OrOperator"));
var ConditionBuilder = (function () {
    function ConditionBuilder(condition) {
        this.condition = condition;
    }
    Object.defineProperty(ConditionBuilder.prototype, "and", {
        get: function () {
            return new IntermediateBuilder_1.default({
                pendingOperation: {
                    condition: this.condition,
                    operation: AndOperator_1.default,
                },
                invert: false,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConditionBuilder.prototype, "or", {
        get: function () {
            return new IntermediateBuilder_1.default({
                pendingOperation: {
                    condition: this.condition,
                    operation: OrOperator_1.default,
                },
                invert: false,
            });
        },
        enumerable: false,
        configurable: true
    });
    ConditionBuilder.prototype.build = function () {
        return this.condition;
    };
    return ConditionBuilder;
}());
exports.default = ConditionBuilder;
